import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, User, SystemMenus } from '../model/shared/model';
import { LocalStorageService } from '../services/shared/local-storage.service';
import { SafeResourceUrl, Title } from '@angular/platform-browser';
import { SelectItem } from 'primeng/api';
import { CommonService } from '../services/shared/common.service';
import { AuthenticationService } from '../services/shared/authentication.service';
import { LanguageService } from '../services/shared/language.service';
 import { MessageType } from '../model/shared/model';
import { EnvService } from '../shared/environment-service/env.service';
declare var $: any;
@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss']
})
export class MasterPageComponent implements OnInit {
  @Input() PageIdInput?: number;
  selectedLangImageUrl: string = "";
  enLangClass: string = "kt-nav__item";
  arLangClass: string = "kt-nav__item";
  systemName: string = "Admin";
  footerSystemName: string = 'CareNet';
  buildNo: string = '';
  selectedSystem: any[] = [];
  user: User;
  UserName: string;
  systemId: number ;
  lastLevelMenus: any[] = [];
  userMenus: MenuItem[] = [];
  originalUserMenus: MenuItem[] = [];
  systemsVirtualPaths: SelectItem[] = [];
  subModules: MenuItem[] = [];
  modules: MenuItem[] = [];
  pages: MenuItem[] = [];
  favPages: MenuItem[] = [];
  showMegaMenu: boolean = false;
  application: MenuItem;
  applicationName: string = "";
 menu: MenuItem[] = [];
  currentYear: number;
 systemMenusList: SystemMenus[];
  systemBaseUrl: string = "";
  portalName: string = "Lab Referral";
  pageId: number;
  isFav = false;
  subModuleId: number;
  language: string;
  PageTitle: string = "";
  moduleId: number;
  showWebSite: boolean = false;
  name: string;
  loggedProvider: any;
  loggedInSettings: any;
  imageLogo: any;
  changePasswordEnabled: boolean;
  showChangePassword: boolean = false;
  
  isCloudManagerEnabled: boolean = false;
   oldPassword: any;
  newPassword: any;
  confirmPassword: any;

  checkMatchPassword: boolean = false;
  constructor(@Inject(DOCUMENT) private document: Document, private localStorageService: LocalStorageService, private router: Router,
    private titleService: Title, private cs: CommonService, private auth: AuthenticationService, public languageService: LanguageService,
    public env: EnvService) {
 
    this.user = this.auth.getLoggedInUser();

 
    if (this.languageService.language == 'en')
      this.selectedLangImageUrl = "assets/media/flags/260-united-kingdom.svg";
    else
      this.selectedLangImageUrl = "assets/media/flags/077-jordan.svg";

    if (this.languageService.language == '' || this.languageService.language == null) {
      this.selectedLangImageUrl = "assets/media/flags/260-united-kingdom.svg";
      this.localStorageService.SetItem('lang', 'en');
    }
    this.isCloudManagerEnabled = this.env.Keys.cloudManagerEnabled;
  }

  async ngOnInit(): Promise<void> {
    this.buildNo = this.env.Keys.buildNo;
    this.systemId = this.env.Keys.systemId;
    this.imageLogo = this.env.Keys.imageLogo;
    this.changePasswordEnabled = this.env.Keys.changePasswordEnabled;
      this.loggedProvider = this.auth.getLoggedInProvider();
      this.loggedInSettings = this.auth.getloggedInSettings();

    this.portalName = this.env.Keys.portalName;
    this.selectedSystem = null;
    let SystemMenus: MenuItem[] = [];
    let LegacySystemMenus: MenuItem[] = [];
    this.currentYear = new Date().getFullYear();
    //Change body class for aside
    this.document.body.classList.value = "kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--fixed kt-subheader--solid kt-aside--enabled kt-aside--fixed kt-aside--minimize";

    if (this.user != null) {
      this.UserName = this.user.Username;
      this.auth.generateApplicationMenus(this.UserName, this.systemId, this.user.CompanyId, this.user.language, this.loggedInSettings.loggedProviderId, this.env.Keys.referralCode).toPromise().then(
        response => {

          if (response) {

            let menus: SystemMenus[] = [];
 
            Array.from(response).forEach((
              item => {

                item.showInMenu = true;
                menus.push(item);
 
                if (item.menuType == 4) {
                  this.lastLevelMenus.push(item);
                }

              }));

            menus = menus.sort((a, b) => a.menuOrder - b.menuOrder);
 
            let appMenus = menus.filter(menu => menu.menuType == 2).sort((a, b) => a.menuOrder - b.menuOrder);
 
            if (appMenus && appMenus.length > 0)
              this.systemName = this.getMenuName(appMenus[0]?.name, appMenus[0]?.name2);

            appMenus.forEach(appMenu => {
              SystemMenus = [...SystemMenus, {
                id: appMenu.id,
                parentId: appMenu.systemMenuId,
                label: this.getMenuName(appMenu.name, appMenu.name2),
                url: appMenu.url,
                AlternativeName: "",
                icon: appMenu.helpPageURL,
                Application: appMenu.applicationId,
                routerLink: appMenu.url,
                formCode: appMenu.formCode,
                moduleCode: appMenu.moduleCode,
                systemCode: appMenu.systemCode,
                command: (event: any) => {
                  this.setSelectedMenu(event.item, appMenu.menuType);
                },
                items: this.GetSubPages(appMenu.menuType + 1, appMenu.id, menus)
              }];
            });

 
            let angularMenu: MenuItem[] = SystemMenus;


            angularMenu.forEach((
              item => {
                this.userMenus = this.userMenus.concat(item.items);
                this.originalUserMenus = this.userMenus.concat(item.items);
              }));


            if (this.userMenus != [])
              this.showMegaMenu = true;

            this.application = angularMenu.filter(app => app.Application == this.env.Keys.systemId)[0];
            this.applicationName = this.application.label;
           // this.pageSessionsService.setSystemId(this.application.Application);


            this.GetAuthorizedMenu(response);

            if (this.router.url != '' && !this.router.url.includes('login')) {
              let url = this.router.url;

              //if (url.startsWith('/'))
              //  url = url.substr(1, this.router.url.length);

              if (this.env.Keys.useGlobalLanding)
                url = this.env.Keys.buildFolderName + url;
              else if (url.startsWith('/'))
                url = url.substr(1, this.router.url.length);

              if (url != '') {

                if (url.indexOf("?") > 0)
                  url = url.substr(0, url.indexOf("?"));

                this.getPageSessionsByUrl(url);
              }
              else {
                this.getModules();
                this.getSubModules(this.moduleId);
                this.getPages(this.subModuleId);
              }
            }

          //  this.GetFavoritePagesByUser().then(data => {
          //    this.isFav = this.favPages.filter(x => x.id == this.PageIdInput).length > 0 ? true : false;
         //   });

          }

        });


      // Show and hide navgation go to website.
      this.showWebSite = false;
      if (this.auth.getLoginSource() == "website") {
        this.showWebSite = true;
      }

      this.getUserInfo();

 

    }

    this.language = this.localStorageService.GetItem('lang');
    if (this.language == "en")
      this.enLangClass = "kt-nav__item kt-nav__item--active";
    else if (this.language == "ar")
      this.arLangClass = "kt-nav__item kt-nav__item--active";
  }

  switchLanguage(lang: string) {
    this.localStorageService.SetItem('lang', lang);
    window.location.reload();

  }


ngAfterViewInit(): void {
    const head = document.getElementsByTagName('body')[0];
    const script = document.createElement('script');
    script.src = "./assets/js/scripts.bundle.js";
    script.type = 'text/javascript';
    const CustomScript = document.createElement('script');
    //CustomScript.src = "./assets/js/custom.js"
    //CustomScript.type = 'text/javascript';
    var oldJs = document.getElementsByTagName('script');
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.src.indexOf('scripts.bundle.js') != -1 && element.src.indexOf('Custom.js') != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
    head.appendChild(CustomScript);

    //$("#liLang_" + this.languageService.language).className = "kt-nav__item kt-nav__item--active";

  }



  AccountSetupProgress() {

    if (this.isCloudManagerEnabled) {
      //this.router.navigateByUrl('account-setup-progress');
      window.location.replace("account-setup-progress");
    }
  }


  logoutUser() {
    this.auth.logOut();
    this.auth.isAuthorized = false;
 
      this.router.navigateByUrl('');
      this.titleService.setTitle("ESKADENIA Software");
     

    this.localStorageService.Clear();
  }

  async GetFavoritePagesByUser() {

    await this.auth.GetFavoritePagesByUser(this.user.Username, this.user.CompanyId, this.user.language).toPromise().then(response => {

      if (response) {
        var ids = [];
        Array.from(response).forEach((
          item => {

            ids.push(item.id);
          }));

        //var ids = data.content.map(x => x.id);
        var favPages = this.systemMenusList.filter(x => ids.includes(x.id)).sort(a => a.id);
        let favMenu: MenuItem[] = [];

        favPages.forEach(appMenu => {

          favMenu = [...favMenu, {
            id: appMenu.id,
            parentId: appMenu.systemMenuId,
            label: response.filter(x => x.id == appMenu.id)[0].name,
            url: appMenu.url,
            AlternativeName: "",
            icon: appMenu.helpPageURL,
            Application: appMenu.applicationId,
            routerLink: appMenu.url,
            formCode: appMenu.formCode,
            moduleCode: appMenu.moduleCode,
            systemCode: appMenu.systemCode,
            command: (event: any) => {
              this.setSelectedMenu(event, appMenu.menuType);
            },
            items: this.GetSubPages(appMenu.menuType + 1, appMenu.id, favPages)
          }];
        });

        favMenu = favMenu.sort(function (a, b) {
          return a.label.localeCompare(b.label); //using String.prototype.localCompare()
        });
        this.favPages = favMenu;
      }
    });
  }

  async setSelectedMenu(item: MenuItem, menuType: number) {
 
    if (item.routerLink != "")
      this.PageTitle = item.label.replace("/", " ");

    if (menuType == 4 || menuType == 3) {

      this.auth.getsystemURL(this.env.Keys.systemId, this.user.CompanyId).toPromise().then(data => {

        let url = "";
        if (data && data.length > 0) {
          this.systemBaseUrl = data[0].url;
          url = data[0].url;
        }

        let routeURL = item.url;
        if (this.env.Keys.useGlobalLanding)
          routeURL = item.url.substring(item.url.indexOf('/') + 1);

        this.router.navigateByUrl(routeURL);
        this.getPageSessionsByUrl(item.url);
        this.setSelectedPage(item.id);
      });
    }

  }

  GetSubPages(Menu_Type: number, Parent_id: number, Data: any): MenuItem[] {
    let MenuPages: MenuItem[] = [];
    let SubMenus = Data.filter(a => a.menuType == Menu_Type && a.systemMenuId == Parent_id && a.showInMenu).sort((a, b) => a.menuOrder - b.menuOrder);

    SubMenus.forEach(subMenus => {
      var urlPrefix: string = "";
      if (this.systemsVirtualPaths) {
        let prefex = this.systemsVirtualPaths.filter(item => parseInt(item.value) == subMenus.applicationId)[0];
        if (prefex) {
          urlPrefix = prefex.label;
        }

      }

      MenuPages = [...MenuPages, {
        id: subMenus.id,
        parentId: subMenus.systemMenuId,
        label: this.getMenuName(subMenus.name, subMenus.name2),
        url: subMenus.url,
        AlternativeName: "",
        Application: this.env.Keys.systemId,
        icon: subMenus.helpPageURL,
        formCode: subMenus.formCode,
        moduleCode: subMenus.moduleCode,
        systemCode: subMenus.systemCode,
        //routerLink: subMenus.applicationId == this.env.Keys.systemId ? (this.GetSubPages(Menu_Type + 1, subMenus.ID, Data).length < 1 ? ("/" + subMenus.url) : "") : urlPrefix + "/" + subMenus.url,
        routerLink: ("/" + subMenus.url),
        command: (event: any) => {

          document.querySelectorAll('.kt-menu__item--active').forEach(x => x.className = "kt-menu__item  kt-menu__item--submenu");
          $("#" + event.id).closest('li')[0].className = "kt-menu__item  kt-menu__item--submenu kt-menu__item--active";

          if (subMenus.url != null && subMenus.applicationId != this.env.Keys.systemId) {
            if (this.GetSubPages(Menu_Type + 1, subMenus.id, Data).length < 1)
              window.location.href = urlPrefix + "/" + subMenus.url;
            // window.open(urlPrefix + "/" + subMenus.url)
          }
          else {
            this.setSelectedMenu(event, subMenus.menuType);
          }
        },
        items: this.GetSubPages(Menu_Type + 1, subMenus.id, Data).length > 0 ? this.GetSubPages(Menu_Type + 1, subMenus.id, Data) : null,
      }];
    });

    return MenuPages;

  }


 

  async GetAuthorizedMenu(response: SystemMenus[]) {
    let menu: MenuItem[] = [];

    if (response) {

      let menus: SystemMenus[] = [];

      Array.from(response).forEach((
        item => {
          item.showInMenu = true;
          menus.push(item);
        }));

      this.systemMenusList = menus;
      let appMenus = menus;
      appMenus.forEach(appMenu => {
        menu = [...menu, {
          id: appMenu.id,
          menuType: appMenu.menuType,
          parentId: appMenu.systemMenuId,
          label: this.getMenuName(appMenu.name, appMenu.name2),
          url: appMenu.url,
          AlternativeName: "",
          Application: appMenu.applicationId,
          icon: "",
          formCode: appMenu.formCode,
          moduleCode: appMenu.moduleCode,
          systemCode: appMenu.systemCode,
          routerLink: appMenu.url,
          command: (event: any) => { },
          items: undefined
        }];
      });

      var page = this.systemMenusList.filter(x => x.id == this.PageIdInput)[0];
      if (page)
        this.SelectPageById(page);
    }

    this.menu = menu;
  }


  SelectPageById(page: SystemMenus) {
    if (page.menuType == 4) {
      $("#" + (page.showInMenu ? page.id : page.systemMenuId)).closest('li')[0].className = "kt-menu__item kt-menu__item--submenu kt-menu__item--active";
      $("#" + (page.showInMenu ? page.id : page.systemMenuId)).closest('div')[0].style = "";
      this.getPageSessionsByUrl(page.url);
    } else {
      $("#" + (page.showInMenu ? page.id : page.systemMenuId)).closest('li')[0].className = "kt-menu__item kt-menu__item--submenu kt-menu__item--open";
    }

    var parentPage = this.systemMenusList.filter(x => x.id == page.systemMenuId)[0];
    if (parentPage != null)
      this.SelectPageById(parentPage);
  }


  getPageSessionsByUrl(url: string) {

    if (url != undefined && url != '') {
      let page = this.menu.filter(page =>
        page.url != undefined &&
        page.url.replace(this.systemBaseUrl, "").toUpperCase() == url.toUpperCase() &&
        (page.menuType == 4)
      )[0];

      if (page != undefined && page != null) {
        if (page.menuType == 4) {
          var showInMenu = this.systemMenusList.filter(x => x.id == page.id)[0].showInMenu ? true : false;
          if (!showInMenu) {
            page = this.menu.filter(p => p.id == page.parentId)[0];
          }
          this.pageId = page.id;
          this.isFav = this.favPages.filter(x => x.id == this.pageId).length > 0 ? true : false;

          let subModule = this.menu.filter(subMod => subMod.id == (page.menuType == 3 ? page.id : page.parentId))[0];

          if (subModule != undefined && subModule != null) {
            this.subModuleId = subModule.id;
            let module = this.menu.filter(mod => mod.id == subModule.parentId)[0];

            if (module != undefined && module != null) {
              this.getModules(module.id);
              this.getSubModules(module.id, subModule.id);
              this.getPages(subModule.id, page.id);
            }
          }
        } else if (page.menuType == 3) {
          this.pageId = page.id;
          this.isFav = this.favPages.filter(x => x.id == this.pageId).length > 0 ? true : false;
          this.pages = [];
          let subModule = this.menu.filter(subMod => subMod.id == page.id)[0];

          if (subModule != undefined && subModule != null) {
            this.subModuleId = subModule.id;
            let module = this.menu.filter(mod => mod.id == subModule.parentId)[0];

            if (module != undefined && module != null) {
              //this.getModules(module.Id);
              this.getSubModules(module.id, subModule.id);
              this.getPages(subModule.id, page.id);
            }
          }
        }
      }
      else {
        this.subModules = [];
        this.pages = [];
      }
    }
  }


  getModules(id?: number) {

    let mainModules: MenuItem[] = [];
    this.modules = [];
    let copyOfMenu = this.menu.map(x => Object.assign([], x));

    if (copyOfMenu.length > 0) {
      mainModules = copyOfMenu.filter(m => m.menuType == 2 && m.Application == this.env.Keys.systemId);
      mainModules.forEach(mod => {
        mod.items = undefined;
        mod.command = (event: any) => {
          this.getModules(event.item.id);
          this.getSubModules(event.item.id);
          this.getPages(this.subModules[0].id);
        };
      });

      if (id == null || id == undefined) {
        this.modules.push(mainModules[0]);
        mainModules.splice(0, 1);

        if (this.modules.length != 0 && mainModules.length > 0) {
          this.modules[0].items = mainModules;
        }
        else {
          this.modules[0].items = undefined;
        }
      }
      else {
        let selectedModule = mainModules.filter(m => m.id == id)[0];
        this.modules.push(selectedModule);

        let i = 0;
        mainModules.forEach(m => {
          if (m.id == id) {
            mainModules.splice(i, 1);
          }
          i += 1;
        });

        if (this.modules.length != 0 && mainModules.length > 0) {
          this.modules[0].items = mainModules;
        }
        else {
          this.modules[0].items = undefined;
        }
      }
    }
  }

  getUserInfo() {
 
    this.auth.GetUserInfo(this.user.Username).toPromise().then(data => {
      if (data) {
        this.name = data.name;
      }
    });
  }

  getSubModules(perentId: number, id?: number) {
    let subMods: MenuItem[] = [];
    let copyOfMenu = this.menu.map(x => Object.assign([], x));
    this.subModules = [];

    if (copyOfMenu.length > 0) {
      subMods = copyOfMenu.filter(sub => sub.menuType == 3 && sub.parentId == perentId);
      subMods.forEach(mod => {
        mod.items = undefined;
        mod.command = (event: any) => {
          if (event.item.url) {
            this.router.navigateByUrl(event.item.url);
          }

          //this.getSubModules(event.item.parentId, event.item.Id);
          this.getPages(event.item.id);
          this.setPageTitle(event.item.label);
          this.subModuleId = event.item.id;
        };
      });

      if (id == null || id == undefined) {
        this.subModules.push(subMods[0]);

        subMods.splice(0, 1);

        if (this.subModules.length != 0 && subMods.length > 0) {
          this.subModules[0].items = subMods;
        }
        else {
          this.subModules[0].items = undefined;
        }
      }
      else {

        let selectedModule = subMods.filter(m => m.id == id)[0];
        this.subModules.push(selectedModule);

        this.selectedSystem = [];
        let systemMenus: SystemMenus = this.systemMenusList.filter(x => x.id == selectedModule.parentId)[0];

        if (systemMenus) {
          this.selectedSystem = [
            {
              label: this.getMenuName(systemMenus?.name, systemMenus?.name2),
              items: null
            }
          ];
        }

        let i = 0;
        subMods.forEach(m => {
          if (m.id == id) {
            subMods.splice(i, 1);
          }
          i += 1;
        });

        if (this.subModules.length != 0 && subMods.length > 0) {
          this.subModules[0].items = subMods;
        }
        else {
          this.subModules[0].items = undefined;
        }
      }

      this.subModuleId = this.subModules[0].id;
    }
 
   // this.pageSessionsService.setModuleId(this.moduleId);
  }
  getPages(moduleId: number, id?: number) {
    let pages: MenuItem[] = [];
    let copyOfMenu = this.menu.map(x => Object.assign([], x));
    this.pages = [];
    if (copyOfMenu.length > 0) {
      pages = copyOfMenu.filter(sub => sub.menuType == 4 && sub.parentId == moduleId);
      if (pages.length == 1)
        this.setPageTitle(pages[0].label);

      pages.forEach(mod => {
        mod.items = undefined;
        mod.command = (event: any) => {

          let routeURL = event.item.url;
          if (this.env.Keys.useGlobalLanding)
            routeURL = event.item.url.substring(event.item.url.indexOf('/') + 1);

          this.router.navigateByUrl(routeURL);
          this.setSelectedPage(event.item.id);
          //this.getPages(event.item.parentId, event.item.Id)

          this.setPageTitle(event.item.label);
        };
      });

      pages = pages.sort((a, b) => a.label.localeCompare(b.label));


      if (pages.length > 0) {
        if (id == null || id == undefined) {
          this.pages.push(pages[0]);
          pages.splice(0, 1);

          if (this.pages.length != 0 && pages.length > 0) {
            this.pages[0].items = pages;
          }
          else {
            this.pages[0].items = undefined;
          }
        }
        else {
          let selectedPage = pages.filter(m => m.id == id)[0];
          this.pages.push(selectedPage);
          this.setPageTitle(selectedPage.label);
          let i = 0;
          pages.forEach(m => {
            if (m.id == id) {
              pages.splice(i, 1);
            }
            i += 1;
          });

          if (this.pages.length != 0 && pages.length > 0) {
            this.pages[0].items = pages;
          }
          else {
            this.pages[0].items = undefined;
          }
        }


        this.pageId = this.pages[0].id;
        this.isFav = this.favPages.filter(x => x.id == this.pageId).length > 0 ? true : false;
      } else {
        this.pages = [];
      }
    }

  }

  setPageTitle(title: string) {
    this.language = this.localStorageService.GetItem('lang');
    // Check language of system.
    title = this.language == "en" ? title = "CareNet - " + title : title = "كيرنت - " + title;

    this.titleService.setTitle(title);

    //for mobile: close menu when click.
    $("#kt_aside_mobile_toggler").click();
    //document.getElementById("kt_aside_mobile_toggler").click();

  }
  selectedPageId: number;
  setSelectedPage(id) {
    if (id != null || id != undefined) {
      this.selectedPageId = id;
      this.getPages(this.subModuleId, this.selectedPageId);
    }
    else
      this.selectedPageId = this.pages[0].id;

  }
  getMenuName(label1: string, label2: string) {
    let menuName: string = "";
    let lang: string = this.localStorageService.GetItem('lang') as string;
    if (lang == null || lang == "en") {
      menuName = label1;
    } else if (lang == "ar") {
      menuName = label2;
    }
    if (menuName == "") {
      menuName = label1;
    }
    return menuName;
  }

  async homePage() {
 
   let url = this.router.url;

      if (url.startsWith('/'))
        url = url.substr(1, this.router.url.length);

      this.getPageSessionsByUrl(url);

  }

  IsValidChangePassword() {
    let IsValid = false;

    IsValid = !this.checkMatchPassword && (this.confirmPassword != null && this.confirmPassword != '') && (this.newPassword != null && this.newPassword != '')
      && (this.oldPassword != null && this.oldPassword != '');

    return IsValid;
  }

  ShowChangePassword() {
    this.showChangePassword = true;

    this.newPassword = null;
    this.confirmPassword = null;
  }

  ChangePassword() {
    this.newPassword == this.confirmPassword ? null : this.cs.pushMessage(MessageType.Warn, "", "Password dose not matches");

    this.auth.UpdatePasswod(this.oldPassword, this.newPassword, this.confirmPassword, this.UserName).subscribe(data => {
      if (!data.isError) {

        //var msg = this.languageService.translateMessage("Success", "General", "OpertaionDoneSuccessfully");
        this.cs.pushMessage(MessageType.Success, null, data.apiMessage);
        this.oldPassword = null;
        this.newPassword = null;
        this.confirmPassword = null;
        this.showChangePassword = false;
      }
      else {
        this.cs.pushMessage(MessageType.Error, null, data.apiMessage);
      }
    });
  }


  CheckMatchPassword(type) {
    this.checkMatchPassword = true;

    if (type == 1) {
      if (this.confirmPassword != null || this.confirmPassword != '')
        this.checkMatchPassword = this.newPassword == this.confirmPassword ? false : true;
    } else if (type == 2) {
      if (this.newPassword != null || this.newPassword != '')
        this.checkMatchPassword = this.newPassword == this.confirmPassword ? false : true;
    }
  }
}
